import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://assessment.infosectrain.com/api',
  //baseURL: 'http://127.0.0.1:8000/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default instance;
